export default {
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  ADD_CATEGORIES(state, category) {
    state.categories.push(Object.assign({}, category))
  },
  UPDATE_CATEGORY(state, category) {
    if(state.categories.length){
      const roleIndex = state.categories.findIndex((t) => t.id == category.id)
      Object.assign(state.categories[roleIndex], category)
    }
    else state.categories = [category]
  },
  DELETE_CATEGORY(state, categoryId) {
    const index = state.categories.findIndex(i => i.id == categoryId)
    if (index > -1) { state.categories.splice(index, 1) }
  },
/////////////////////////////////////////////
  SET_QUESTIONS(state, questions) {
    state.questions = questions
  },
  UPDATE_QUESTION(state, questions) {
    if(state.questionss.length){
      const roleIndex = state.questionss.findIndex((t) => t.id == questions.id)
      Object.assign(state.questionss[roleIndex], questions)
    }
    else state.questionss = [questions]
  },

  SET_TESTS(state, tests) {
    state.tests = tests
  },
  ADD_TEST(state, test) {
    state.tests.push(Object.assign({}, test))
  },
  UPDATE_TEST(state, test) {
    if(state.tests.length){
      const roleIndex = state.tests.findIndex((t) => t.id == test.id)
      Object.assign(state.tests[roleIndex], test)
    }
    else state.tests = [test]
  },
  DELETE_TEST(state, testId) {
    const index = state.tests.findIndex(i => i.id == testId)
    if (index > -1) { state.tests.splice(index, 1) }
  },
  
  SET_PACKAGES(state, packages) {
    state.packages = packages
  },
  ADD_PACKAGE(state, packag) {
    state.packages.push(Object.assign({}, packag))
  },
  UPDATE_PACKAGE(state, packag) {
    if(state.packages.length){
      const roleIndex = state.packages.findIndex((t) => t.id == packag.id)
      Object.assign(state.packages[roleIndex], packag)
    }
    else state.packages = [packag]
  },
  DELETE_PACKAGE(state, packageId) {
    const index = state.packages.findIndex(i => i.id == packageId)
    if (index > -1) { state.packages.splice(index, 1) }
  },

  SET_BANNERS(state, banners) {
    state.banners = banners
  },
  ADD_BANNER(state, banner) {
    state.banners.push(Object.assign({}, banner))
  },
  UPDATE_BANNER(state, banner) {
    if(state.banners.length){
      const roleIndex = state.banners.findIndex((t) => t.id == banner.id)
      Object.assign(state.banners[roleIndex], banner)
    }
    else state.banners = [banner]
  },
  DELETE_BANNER(state, bannerId) {
    const index = state.banners.findIndex(i => i.id == bannerId)
    if (index > -1) { state.banners.splice(index, 1) }
  },

  SET_ADVERTISMENTS(state, advertisments) {
    state.advertisments = advertisments
  },
  ADD_ADVERTISMENT(state, advertisments) {
    state.advertisments.push(Object.assign({}, advertisments))
  },
  UPDATE_ADVERTISMENT(state, advertisments) {
    if(state.advertisments.length){
      const roleIndex = state.advertisments.findIndex((t) => t.id == advertisments.id)
      Object.assign(state.advertisments[roleIndex], advertisments)
    }
    else state.advertisments = [advertisments]
  },
  DELETE_ADVERTISMENT(state, advertisementId) {
    const index = state.advertisments.findIndex(i => i.id == advertisementId)
    if (index > -1) { state.advertisments.splice(index, 1) }
  },

  SET_SIGNS(state, signs) {
    state.signs = signs
  },
  ADD_SIGN(state, signs) {
    state.signs.push(Object.assign({}, signs))
  },
  UPDATE_SIGN(state, signs) {
    if(state.signs.length){
      const roleIndex = state.signs.findIndex((t) => t.id == signs.id)
      Object.assign(state.signs[roleIndex], signs)
    }
    else state.signs = [signs]
  },
  DELETE_SIGN(state, signId) {
    const index = state.signs.findIndex(i => i.id == signId)
    if (index > -1) { state.signs.splice(index, 1) }
  },

  SET_SIGN_CATEGORYS(state, sign_categories) {
    state.sign_categories = sign_categories
  },
  ADD_SIGN_CATEGORY(state, sign_categories) {
    state.sign_categories.push(Object.assign({}, sign_categories))
  },
  UPDATE_SIGN_CATEGORY(state, sign_categories) {
    if(state.sign_categories.length){
      const roleIndex = state.sign_categories.findIndex((t) => t.id == sign_categories.id)
      Object.assign(state.sign_categories[roleIndex], sign_categories)
    }
    else state.sign_categories = [sign_categories]
  },
  DELETE_SIGN_CATEGORY(state, signId) {
    const index = state.sign_categories.findIndex(i => i.id == signId)
    if (index > -1) { state.sign_categories.splice(index, 1) }
  },

  SET_THEORIES(state, theories) {
    state.theories = theories
  },
  ADD_THEORY(state, theories) {
    state.theories.push(Object.assign({}, theories))
  },
  UPDATE_THEORY(state, theories) {
    if(state.theories.length){
      const roleIndex = state.theories.findIndex((t) => t.id == theories.id)
      Object.assign(state.theories[roleIndex], theories)
    }
    else state.theories = [theories]
  },
  DELETE_THEORY(state, theoryId) {
    const index = state.theories.findIndex(i => i.id == theoryId)
    if (index > -1) { state.theories.splice(index, 1) }
  },
}
